export default __webpack_public_path__ + "static/media/facebook.acc2eb54.svg";